import { useAdminLocale } from '../../lib/admin-locale.js';
import { useTheme } from '../../lib/theme.js';
import { Icon } from './Icon.js';
import { Select } from './Select.js';
import { cx } from './utils.js';

/** Compact icon button for the shell header. */
export function ThemeToggle(props: { className?: string }) {
  const { text } = useAdminLocale();
  const { theme, toggleTheme } = useTheme();
  const dark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={
        dark
          ? text('Αλλαγή σε φωτεινό θέμα', 'Switch to light theme')
          : text('Αλλαγή σε σκουρό θέμα', 'Switch to dark theme')
      }
      aria-label={
        dark
          ? text('Αλλαγή σε φωτεινό θέμα', 'Switch to light theme')
          : text('Αλλαγή σε σκουρό θέμα', 'Switch to dark theme')
      }
      className={cx(
        'inline-flex items-center justify-center rounded-[var(--admin-radius-sm)] border border-[color:var(--admin-border)] bg-[color:var(--admin-surface)] p-1.5 text-slate-600 transition hover:bg-slate-50 hover:text-slate-900 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100',
        props.className,
      )}
    >
      <Icon name={dark ? 'sun' : 'moon'} className="size-4" />
    </button>
  );
}

/** Full control for Settings. */
export function ThemeSelect(props: { className?: string }) {
  const { text } = useAdminLocale();
  const { theme, setTheme } = useTheme();
  return (
    <Select
      className={props.className ?? 'mt-1.5'}
      aria-label={text('Θέμα εμφάνισης', 'Appearance theme')}
      value={theme}
      onChange={(next) => setTheme(next === 'dark' ? 'dark' : 'light')}
      options={[
        { value: 'light', label: text('Φωτεινό (Light)', 'Light') },
        { value: 'dark', label: text('Σκοτεινό (Dark)', 'Dark') },
      ]}
    />
  );
}
